module.exports = __webpack_public_path__ + "img/share-linke-logo.265208fd.svg";